<mat-form-field>
  <mat-label>{{ label }}</mat-label>
  <mat-select #sel (selectionChange)="onSelectionChange($event.value)" [value]="value" multiple>
    <button mat-button class="text-sm" (click)="selectAll(sel)">
        Select All
      </button>
      <button mat-button class="text-sm" (click)="deselectAll(sel)">
        Deselect All
      </button>
    <mat-option *ngFor="let item of items" [value]="item[idProp]">{{item[labelProp]}}</mat-option>
  </mat-select>
</mat-form-field>